







































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import alatReuseStore from "@/store/modules/AlatReuseStore";
import Service from "@/services/AlatReuseService";
import http from "@/axios/http-common";
import { METODE_STERILISASI, REUSE_STATUS_META } from "@/constants/alatReuseOptions";
import {
  CanReuseResponse,
  MasterAlatReuse,
  PenggunaanAlatReuse
} from "@/types/alat_reuse";

@Component
export default class PenggunaanAlatReusePage extends Vue {
  filter: any = {
    tgl_dari: "",
    tgl_sampai: "",
    master_alat_reuse_id: null,
    search: ""
  };

  dialog = false;
  deleteDialog = false;
  saving = false;
  editingId: number | null = null;
  toDelete: PenggunaanAlatReuse | null = null;
  errors: Record<string, string[]> = {};

  masterOptions: MasterAlatReuse[] = [];
  currentStatus: CanReuseResponse | null = null;

  // Pasien search state
  pasienItems: any[] = [];
  pasienLoading = false;
  pasienSearch: string | null = null;
  selectedPasien: any = null;

  // Register & persetujuan re-use state
  registerItems: any[] = [];
  registerLoading = false;
  consentList: any[] = [];
  consentLoading = false;

  metodeSterilisasiOptions = METODE_STERILISASI;

  form: any = this.emptyForm();

  headers = [
    { text: "Tanggal", value: "tanggal_penggunaan", width: 110 },
    { text: "Pasien", value: "pasien" },
    { text: "Alat Reuse", value: "alat" },
    { text: "Ruang", value: "ruang_rawat", width: 150 },
    { text: "Jenis Operasi", value: "jenis_operasi" },
    { text: "Penggunaan Ke", value: "penggunaan_ke", width: 140, align: "center" },
    { text: "", value: "actions", sortable: false, width: 90 }
  ];

  get loading() { return alatReuseStore.loading; }
  get penggunaanList() { return alatReuseStore.penggunaanList; }

  get statusMeta() {
    if (!this.currentStatus) return REUSE_STATUS_META.aman;
    return REUSE_STATUS_META[this.currentStatus.status] || REUSE_STATUS_META.aman;
  }

  get statusAlertType(): "success" | "warning" | "error" | "info" {
    if (!this.currentStatus) return "info";
    const s = this.currentStatus.status;
    if (s === "aman") return "success";
    if (s === "mendekati_batas") return "warning";
    return "error";
  }

  get canSubmit(): boolean {
    if (!this.form.master_alat_reuse_id) return false;
    if (!this.form.nama_pasien) return false;
    if (!this.form.tanggal_penggunaan) return false;
    if (!this.form.ruang_rawat) return false;
    if (!this.form.sterilisasi_sebelum_pakai) return false;
    // Hard-block saat batas tercapai / ditarik
    if (!this.editingId && this.currentStatus && !this.currentStatus.can_reuse) return false;
    return true;
  }

  emptyForm() {
    return {
      master_alat_reuse_id: null,
      kode_unit_alat: "",
      pasien_rm: "",
      nama_pasien: "",
      register_id: null,
      unit_id: null,
      tanggal_penggunaan: localISODate(),
      jenis_operasi: "",
      ruang_rawat: "",
      sterilisasi_sebelum_pakai: true,
      tanggal_sterilisasi: "",
      metode_sterilisasi: null,
      catatan: ""
    };
  }

  async mounted() {
    await Promise.all([this.loadData(), this.loadMasterOptions()]);
  }

  async loadData() {
    await alatReuseStore.loadPenggunaan({
      tgl_dari: this.filter.tgl_dari || undefined,
      tgl_sampai: this.filter.tgl_sampai || undefined,
      master_alat_reuse_id: this.filter.master_alat_reuse_id || undefined,
      search: this.filter.search || undefined
    });
  }

  async loadMasterOptions() {
    const res = await Service.masterList({ params: { per_page: 200, aktif: 1 } });
    const d = res.data.data;
    this.masterOptions = d.data || d || [];
  }

  masterItemText(item: MasterAlatReuse) {
    return `${item.kode_alat} — ${item.nama_alat} (max ${item.max_penggunaan}x)`;
  }

  async openCreate() {
    this.editingId = null;
    this.form = this.emptyForm();
    this.errors = {};
    this.currentStatus = null;
    this.selectedPasien = null;
    this.pasienItems = [];
    if (this.masterOptions.length === 0) await this.loadMasterOptions();
    this.dialog = true;
  }

  openEdit(item: PenggunaanAlatReuse) {
    this.editingId = item.id;
    this.form = {
      master_alat_reuse_id: item.master_alat_reuse_id,
      kode_unit_alat: item.kode_unit_alat || "",
      pasien_rm: item.pasien_rm || "",
      nama_pasien: item.nama_pasien,
      register_id: item.register_id || null,
      unit_id: item.unit_id || null,
      tanggal_penggunaan: item.tanggal_penggunaan,
      jenis_operasi: item.jenis_operasi || "",
      ruang_rawat: item.ruang_rawat,
      sterilisasi_sebelum_pakai: !!item.sterilisasi_sebelum_pakai,
      tanggal_sterilisasi: item.tanggal_sterilisasi || "",
      metode_sterilisasi: item.metode_sterilisasi || null,
      catatan: item.catatan || ""
    };
    this.currentStatus = null;
    this.consentList = [];
    this.registerItems = [];
    if (item.pasien_rm) this.loadRegisters(item.pasien_rm);
    if (item.register_id) this.loadConsent(item.register_id);
    this.errors = {};
    this.dialog = true;
  }

  async onAlatChange() {
    await this.refreshStatus();
  }

  async refreshStatus() {
    if (!this.form.master_alat_reuse_id || this.editingId) return;
    try {
      this.currentStatus = await alatReuseStore.checkReuseStatus({
        masterAlatId: this.form.master_alat_reuse_id,
        kodeUnit: this.form.kode_unit_alat || undefined
      });
    } catch (e) {
      this.currentStatus = null;
    }
  }

  // ---- Pasien search ----
  pasienFilter(item: any, queryText: string) {
    const q = (queryText || "").toLowerCase();
    return (
      String(item.rm || "").toLowerCase().indexOf(q) > -1 ||
      String(item.nama || "").toLowerCase().indexOf(q) > -1
    );
  }

  async doPasienSearch() {
    if (!this.pasienSearch) {
      this.pasienItems = [];
      return;
    }
    this.pasienLoading = true;
    try {
      const res = await http.getDataParam("/pasien", {
        params: { term: this.pasienSearch }
      });
      this.pasienItems = res.data || [];
    } catch (e) {
      this.pasienItems = [];
    } finally {
      this.pasienLoading = false;
    }
  }

  onPasienSelect(v: any) {
    this.form.register_id = null;
    this.consentList = [];
    if (v && typeof v === "object") {
      this.form.pasien_rm = v.rm;
      this.form.nama_pasien = v.nama;
      this.loadRegisters(v.rm);
    } else {
      this.registerItems = [];
    }
  }

  // ---- Register & persetujuan re-use ----
  async loadRegisters(rm: string) {
    if (!rm) {
      this.registerItems = [];
      return;
    }
    this.registerLoading = true;
    try {
      const resp = await http.getData(`/pasien/${rm}/register`);
      const body = resp.data;
      this.registerItems = Array.isArray(body) ? body : body?.data || [];
    } catch (e) {
      this.registerItems = [];
    } finally {
      this.registerLoading = false;
    }
  }

  registerItemText(reg: any): string {
    const unit = reg.unit && typeof reg.unit === "object" ? reg.unit.nama : reg.unit;
    return `Register ${reg.register} · Masuk ${reg.masuk || "-"} · ${unit || "-"}`;
  }

  onRegisterChange(registerId: number | null) {
    this.consentList = [];
    if (!registerId) {
      this.form.unit_id = null;
      return;
    }
    const reg = this.registerItems.find(r => r.register === registerId);
    if (reg && reg.unit && typeof reg.unit === "object") {
      this.form.unit_id = reg.unit.id || null;
      if (!this.form.ruang_rawat) this.form.ruang_rawat = reg.unit.nama || "";
    }
    this.loadConsent(registerId);
  }

  async loadConsent(registerId: number) {
    this.consentLoading = true;
    try {
      const resp = await http.getData(`/register/${registerId}/persetujuan-reuse`);
      this.consentList = resp.data?.data || [];
    } catch (e) {
      this.consentList = [];
    } finally {
      this.consentLoading = false;
    }
  }

  get consentStatus(): { color: string; icon: string; label: string; caption: string } {
    if (this.consentLoading) {
      return { color: "grey", icon: "mdi-loading", label: "Memeriksa persetujuan…", caption: "" };
    }
    const latest = this.consentList.length ? this.consentList[0] : null;
    if (!latest) {
      return {
        color: "warning",
        icon: "mdi-alert",
        label: "Persetujuan re-use BELUM ADA",
        caption: "Buat di Tab Persetujuan Ranap — pencatatan tetap bisa disimpan."
      };
    }
    if (latest.is_setuju === false) {
      return {
        color: "error",
        icon: "mdi-close-octagon",
        label: "Pasien MENOLAK re-use",
        caption: `No. ${latest.nomor || "-"} — periksa kembali sebelum memakai alat re-use.`
      };
    }
    const ttdLengkap = latest.signed_dpjp && latest.signed_penyetuju;
    return {
      color: ttdLengkap ? "success" : "teal",
      icon: "mdi-check-decagram",
      label: ttdLengkap ? "Persetujuan re-use ADA (TTD lengkap)" : "Persetujuan ADA (TTD belum lengkap)",
      caption: `No. ${latest.nomor || "-"}`
    };
  }

  // ---- Save ----
  async save() {
    this.saving = true;
    this.errors = {};
    try {
      if (this.editingId) {
        await alatReuseStore.updatePenggunaan({ id: this.editingId, data: this.form });
      } else {
        await alatReuseStore.createPenggunaan(this.form);
      }
      this.dialog = false;
      await this.loadData();
    } catch (e) {
      const err = e as any;
      if (err && err.response && err.response.data && err.response.data.errors) {
        this.errors = err.response.data.errors;
      }
    } finally {
      this.saving = false;
    }
  }

  confirmDelete(item: PenggunaanAlatReuse) {
    this.toDelete = item;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.toDelete) return;
    this.saving = true;
    try {
      await alatReuseStore.deletePenggunaan(this.toDelete.id);
      this.deleteDialog = false;
      this.toDelete = null;
      await this.loadData();
    } finally {
      this.saving = false;
    }
  }

  printPdf() {
    Service.printPenggunaanPdf({
      tgl_dari: this.filter.tgl_dari || undefined,
      tgl_sampai: this.filter.tgl_sampai || undefined,
      master_alat_reuse_id: this.filter.master_alat_reuse_id || undefined,
    });
  }

  // ---- Formatters ----
  formatDate(s: string) {
    if (!s) return "-";
    const d = new Date(s);
    return d.toLocaleDateString("id-ID");
  }

  usageChipColor(item: PenggunaanAlatReuse) {
    const max = item.master?.max_penggunaan || 0;
    if (!max) return "grey";
    const ratio = item.penggunaan_ke / max;
    if (ratio >= 1) return "error";
    if (ratio >= 0.8) return "warning";
    return "success";
  }
}
